//====================================================
//  Function: Reposition Homepage
//====================================================
var mainContent;
var rightSideContent;

function componentsRepositionHomepage() {
  if ($(".in-index").length > 0) {
    mainContent = $("#content-wrapper");
    rightSideContent = $("#content");

    // reposition welcome
    repositionWelcome();

    // reposition Blog
    repositionBlog();

    // add slider for carousel
    addCarouselSliderForCarousel();

    // add slider for top products
    if($('.homepage-box').length && $('.homepage-group-title').length) {
      addCarouselSliderForTopProducts();
    }
  }
}

function repositionWelcome() {
  var welcomeBlock = $(".homepage-box.welcome-wrapper");
  mainContent.append(welcomeBlock);
}

function repositionBlog() {
  if ($(".blog-hp").length > 0) {
    var blog = $(".blog-hp");
    rightSideContent.append(blog);
    $(".blog-hp").wrapInner('<div class="blog-hp-items"></div>');
  }
}

function addCarouselSliderForTopProducts() {
  $('.products-block').addClass('carousel__specific_style');
  $('.products-block .product').addClass('carousel__slide');

  document.querySelectorAll(".carousel__specific_style").forEach(carousel => {
    new Carousel(carousel, {
      Dots: true,
      Navigation: false,
      Autoplay: {
          timeout : 3000,
          hoverPause : true,
      },
    });
  });

  $('.carousel__specific_style').each(function() {
    var productsCount = $(this).find('.product').length;
    if (productsCount <= 2) {
        $(this).addClass('carousel-minimal-products');
    }
  });
}

function addCarouselSliderForCarousel() {

  $('.carousel-inner').addClass('carousel_banner__specific_style');
  $('.carousel-inner .item').addClass('carousel__slide');

  new Carousel(document.querySelector(".carousel-inner"), {
    Dots: true,
    Navigation: false,
    Autoplay: {
        timeout : 3000,
        hoverPause : true,
    },
  })
}